
const px2rem = require('postcss-px2rem')

// 配置基本大小
// const postcss = px2rem({
//   // 基准大小 baseSize，需要和rem.js中相同
//   remUnit: 16
// })


module.exports = {
	lintOnSave: false,
	publicPath: './',
	devServer: {
		proxy: {
			'/api': {
				target: 'https://health.qingleitech.com',      // 生产环境
				// target: 'https://dev.qingleitech.com',    // 测试环境
				// target: 'http://ccyy.qingleitech.com',    // 测试环境
				// target: 'https://dev.tsingraytech.com',      // AWS测试

				// target: 'http://192.168.1.195:9527',    // 老于本地
				// target: 'http://192.168.1.79:9527',    // 祥达本地


				// 福寿康相关
				// target: 'http://172.21.0.124:9527', //于俊伟-福寿康测试
				// target: 'http://172.22.0.211:9527', //于俊伟-福寿康生产

				// 爱赡养相关
				// target: 'http://192.168.7.3:9527', //于俊伟-爱赡养测试
				// target: 'http://10.0.5.2:9527', //于俊伟-爱赡养生产

				// 安益同相关
				// target: 'http://47.95.146.239:9527', //于俊伟-安益同测试
				// target: 'http://172.16.19.207:9527', //于俊伟-安益同生产

				// 远盟相关
				// target: 'http://yuanmeng.qingleitech.com', //于俊伟-远盟测试

				ws: true,
				changeOrigin: true,
				pathRewrite: {
					'^/api': '/api'
				}
			},
			'/aliyun-tts': {
				target: 'https://nls-gateway-cn-shanghai.aliyuncs.com',
				changeOrigin: true,
				ws: false,
				pathRewrite: {
					'^/aliyun-tts': '/stream/v1/tts'
				}
			}
		}
	},
	transpileDependencies: process.env.NODE_ENV === "development" ? ["*"] : [],
	css: {
		// loaderOptions: {
		//   postcss: {
		//     plugins: [
		//       postcss
		//     ]
		//   }
		// }
		loaderOptions: {
			less: {
			  javascriptEnabled: true,
			}
		}
	},
	// configureWebpack: {
	// 	devtool: 'source-map'
	// }

};